import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseByMonthDatatable";

import {
  getSingleMonthlyTakaTransferRedux,
  getSingleMonthlyCurrencySellRedux,
  getSingleMonthlySpendCashRedux,
} from "../../../actions/index";
import { Link } from "react-router-dom";

import { connect } from "react-redux";

export class MonthlyExpenseByMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
    };
  }

  componentDidMount = async () => {
    const [type, month] = this.props.match.params.month.split("-");
    if (type === "expense") {
      this.props.getSingleMonthlyTakaTransferRedux(month);
    } else if (type == "spendCash") {
      this.props.getSingleMonthlySpendCashRedux(month);
    } else {
      this.props.getSingleMonthlyCurrencySellRedux(month);
    }
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  render() {
    const { open } = this.state;
    const [type, month] = this.props.match.params.month.split("-");
    console.log(this.props);
    return (
      <Fragment>
        <Breadcrumb
          title={
            type === "expense"
              ? "Taka Transfer"
              : type == "spendCash"
              ? "Spend Cash"
              : "Currency Sell"
          }
          parent="expense history"
        />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div
                  className="card-header"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>
                    <i
                      className="icofont-calendar"
                      style={{
                        fontSize: "130%",
                        marginRight: "5px",
                        color: "darkblue",
                      }}
                    ></i>
                    {month}
                  </h5>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      history={this.props.history}
                      multiSelectOption={false}
                      myData={
                        type === "expense"
                          ? this.props.allExpenses
                          : type == "spendCash"
                          ? this.props.allSpendCash
                          : this.props.allCashIns
                      }
                      pageSize={50}
                      pagination={true}
                      class="-striped -highlight"
                      type={type}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allExpenses: state.expenses.singleMonthExpense,
    allCashIns: state.cashIns.singleMonthCashIn,
    allSpendCash: state.spendCash.singleMonthSpendCash,
  };
};

export default connect(mapStateToProps, {
  getSingleMonthlyTakaTransferRedux,
  getSingleMonthlyCurrencySellRedux,
  getSingleMonthlySpendCashRedux,
})(MonthlyExpenseByMonth);
